import { ActivePeriodTimePicker } from 'Services/ProductManagement/Features/Product/Components/ActivePeriodTimePicker'
import type { Validity } from 'Services/ProductManagement/Features/Product/types'
import { Checkbox, FormControlLabel } from '@mui/material'
import { Box } from '@mui/system'
import { t } from 'ttag'

interface ActivePeriodWholeDayInputProps {
  isChecked: boolean
  handleCheckedChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  activePeriod: Validity
  handleTimePickerChange: (value: Date | null, name: string, periodToUpdate: Validity) => void
}

export default function ActivePeriodWholeDayInput({
  isChecked,
  handleCheckedChange,
  activePeriod,
  handleTimePickerChange
}: Readonly<ActivePeriodWholeDayInputProps>) {
  const handleTimeChange = (value: Date | null, name: string) => {
    handleTimePickerChange(value, name, activePeriod)
  }

  return (
    <Box
      sx={{
        '& .MuiFormControl-root': {
          marginTop: 0,
          marginBottom: 1
        }
      }}
    >
      <FormControlLabel
        control={<Checkbox checked={isChecked} onChange={handleCheckedChange} />}
        label={t`Whole day`}
      />
      <Box>
        {!isChecked && activePeriod && (
          <ActivePeriodTimePicker
            activePeriod={activePeriod}
            handleTimePickerChange={handleTimeChange}
            isRequired={!isChecked}
            timeOfDayRestriction={false}
          />
        )}
      </Box>
    </Box>
  )
}
